module.exports = __webpack_public_path__ + "img/plane_enemy2.fcf55672.png";